<template>
    <v-app class="app">
        <header class="header">
            <v-container class="header-content">
                <div class="logo-brand">
                    <router-link to="/" class="logo-link">
                        <img src="@/assets/logo.jpg" class="logo-img" alt="FlashX" />
                        <span class="logo-text">FLASHX</span>
                    </router-link>
                </div>

                <nav class="nav-links">
                    <router-link to="/" class="nav-link" active-class="active">Главная</router-link>
                    <router-link to="/faq" class="nav-link" active-class="active">Часто спрашивают</router-link>
                </nav>

            </v-container>
        </header>

        <v-main class="main-content">
            <router-view />
        </v-main>

        <footer class="footer">
            <v-container>
                <div>
                    <p>&copy; 2026 FLASHX. Все права защищены.</p>
                </div>
            </v-container>
        </footer>
    </v-app>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {}
    }
}
</script>

<style>
    body {
        background: #ffffff !important;
        color: #000000 !important;
    }

    .app {
        background: #ffffff;
    }

    /* ============ HEADER ============ */
    .header {
        position: sticky;
        top: 0;
        z-index: 100;
        background: #ffffff;
        border-bottom: 1px solid rgba(0, 0, 0, 0.08);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    }

    .header-content {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 80px;
        padding: 0 24px;
    }

    .logo-brand {
        flex: 0 0 auto;
    }

    .logo-link {
        display: flex;
        align-items: center;
        gap: 12px;
        text-decoration: none;
        transition: transform 0.3s;
    }

    .logo-link:hover {
        transform: scale(1.05);
    }

    .logo-img {
        width: 40px;
        height: 40px;
        border-radius: 8px;
        object-fit: cover;
    }

    .logo-text {
        font-size: 20px;
        font-weight: 800;
        color: #000000;
        letter-spacing: 1px;
    }

    .nav-links {
        display: flex;
        gap: 48px;
        flex: 1;
        margin-left: 80px;
        align-items: center;
    }

    .nav-link {
        font-size: 15px;
        font-weight: 600;
        color: #000000;
        text-decoration: none;
        position: relative;
        transition: color 0.3s;
        white-space: nowrap;
    }

    .nav-link:hover {
        color: #000000;
    }

    .nav-link.active {
        color: #000000;
    }

    .nav-link.active::after {
        content: '';
        position: absolute;
        bottom: -8px;
        left: 0;
        right: 0;
        height: 2px;
        background: #000000;
    }

    .header-actions {
        display: flex;
        gap: 16px;
        align-items: center;
        flex: 0 0 auto;
    }

    .btn-text {
        color: #000000 !important;
        font-weight: 600;
        transition: color 0.3s;
    }

    .btn-text:hover {
        color: #000000 !important;
    }

    .btn-signup {
        background: #000000 !important;
        color: white !important;
        border-radius: 30px;
        padding: 8px 24px !important;
        font-weight: 600;
        transition: all 0.3s;
    }

    .btn-signup:hover {
        background: #000000 !important;
        transform: translateY(-2px);
    }

    /* ============ MAIN ============ */
    .main-content {
        padding: 0;
        background: #ffffff;
    }

    /* ============ FOOTER ============ */
    .footer {
        background: #f8f8f8;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        padding: 80px 0 40px;
        margin-top: 120px;
    }

    .footer-content {
        display: grid;
        grid-template-columns: 2fr 1fr 1fr 1fr;
        gap: 60px;
        margin-bottom: 60px;
    }

    .footer-section h4 {
        font-size: 20px;
        font-weight: 800;
        color: #000000;
        margin-bottom: 12px;
        letter-spacing: -0.5px;
    }

    .footer-section h5 {
        font-size: 14px;
        font-weight: 700;
        color: #000000;
        margin-bottom: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .footer-section p {
        font-size: 14px;
        color: #666666;
        line-height: 1.6;
    }

    .footer-section a {
        display: block;
        font-size: 14px;
        color: #666666;
        text-decoration: none;
        margin-bottom: 12px;
        transition: color 0.3s;
    }

    .footer-section a:hover {
        color: #000000;
    }

    .footer-section router-link {
        display: block;
        font-size: 14px;
        color: #666666;
        text-decoration: none;
        margin-bottom: 12px;
        transition: color 0.3s;
    }

    .footer-section router-link:hover {
        color: #000000;
    }

    .footer-bottom {
        padding-top: 40px;
        border-top: 1px solid rgba(0, 0, 0, 0.08);
        text-align: center;
    }

    .footer-bottom p {
        font-size: 13px;
        color: #888888;
    }

    /* ============ RESPONSIVE ============ */
    @media (max-width: 960px) {
        .header-content {
            height: 70px;
            padding: 0 20px;
        }

        .logo-text {
            font-size: 18px;
        }

        .logo-img {
            width: 36px;
            height: 36px;
        }

        .nav-links {
            margin-left: 40px;
            gap: 32px;
        }

        .nav-link {
            font-size: 14px;
        }

        .header-actions {
            gap: 12px;
        }

        .footer-content {
            grid-template-columns: 1fr 1fr;
            gap: 40px;
        }
    }

    @media (max-width: 768px) {
        .header-content {
            height: 64px;
            padding: 0 16px;
        }

        .logo-text {
            font-size: 16px;
        }

        .logo-img {
            width: 32px;
            height: 32px;
        }

        .nav-links {
            margin-left: 24px;
            gap: 24px;
        }

        .nav-link {
            font-size: 13px;
        }
    }

    @media (max-width: 600px) {
        .header-content {
            height: 56px;
            padding: 0 12px;
        }

        .logo-brand {
            flex: 0 0 auto;
        }

        .logo-text {
            display: none;
        }

        .logo-img {
            width: 32px;
            height: 32px;
        }

        .nav-links {
            margin-left: auto;
            gap: 16px;
            flex: 0 0 auto;
        }

        .nav-link {
            font-size: 12px;
        }

        .header-actions {
            display: none;
        }

        .footer-content {
            grid-template-columns: 1fr;
            gap: 32px;
        }
    }
</style>
